// import { useEffect, useState } from "react";
// import LoginForm from "../../@components/LoginForm";
// import ResetLoginForm from "../../@components/ResetLoginForm";
// import { useSelector } from "react-redux";
// import { RootState } from "../../store/store";
// import { getLocalStorage } from "../../helpers/get-set-local-storage";
import { useNavigate } from "react-router-dom";
import { localStorageConstants } from "../../constants/localStorageConstants";
// import Header from "../../@components/Header";
import {
  Auth,
  // AuthProvider,
  OmniAuthProvider,
  // useOmniAuth,
} from "@cars24/omniauth";
import { useDispatch } from "react-redux";
import { getLocalStorage, setLocalStorage } from "../../helpers/get-set-local-storage";
import { setMessage } from "../../../store/slices/Notification";
import { getOmniAuthData } from "../../apiHandler/auth.service";
import { useEffect } from "react";
// import AllRoutes from "../../config/Routes";

function mapData(input:any) {
  return Object.keys(input).map((key) => {
    return {
      tenantId: key, // Use the key of the object as tenantId
      roleNames: input[key].OPS ? ["PUBLISHER"] : [], // Assuming "PUBLISHER" is the role name for OPS
    };
  });
}

const LoginPage = () => {
  // const { isAuthenticated } = useOmniAuth();
  const method: "GoogleSSO" | "OTP" = "GoogleSSO";
  const navigation = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    const token = getLocalStorage(localStorageConstants.TOKEN);
    if (token) {
      window.location.href = "/dashboard";
    }
  }, []);
  const onSuccess = async (data: any) => {
    // const profileResp = await getOmniAuthData(data?.session?.accessToken);
    const userTenants = mapData(data.user.tenantRolesMapping);
  
    if (Object.keys(data?.user).length) {
      setLocalStorage(localStorageConstants.TOKEN, data?.session?.accessToken);
      setLocalStorage(localStorageConstants.USER, {
        ...data?.user,
        userTenants,
      });
      dispatch(
        setMessage({
          type: "success",
          message: "Login successful",
        })
      );
      navigation("/dashboard");
    }
  };
  const onError = () => {
    // if (Object.keys(data?.error).length) {
    //   dispatch(
    //     setMessage({
    //       type: "error",
    //       message: data?.error?.message,
    //     })
    //   );
    // }
  };
  const config = {
    method: method,
    clientId: "user-notification-panel",
    googleClientId:
      "565623820835-c8ifgjo1sfi6klr1mjc41jcdjpgq3cum.apps.googleusercontent.com" ||
      "",
    clientSecret: process.env.REACT_APP_COSMONAUT_SECRET_KEY || "",
    xChannelName: "APP",
    xTenantCode: "USER_NOTIFICATION",
    umsBaseUrl: process.env.REACT_APP_COSMONAUT_API || "",
    redirectUri:
      typeof window !== "undefined" ? `${window.location.origin}/login` : "",
    onSuccess: (e: any) => {
      // console.log("avcde", e);
      onSuccess(e);
    },
    onError: () => {
      onError();
    },
  };
  return (
    <OmniAuthProvider config={config}>
      {/* ( */}
      <Auth flow="UMS" />
      {/* )} */}
      {/* <h1 className="mt-[100px]">VIpin Sharma</h1> */}
    </OmniAuthProvider>
  );
};

export default LoginPage;
